// Universal Quality Engine — VR / Mobile / Desktop performance profiles.
// VR is tuned for a rock-solid 90 FPS in-headset; Desktop runs full 8K density.
export const PROFILES = {
  vr: { dpr: 1, rain: 1800, snow: 2200, debris: 14, stars: 2500, sphere: 64, cloud: 64, ocean: 96, cityMult: 0.7 },
  mobile: { dpr: 1.5, rain: 2200, snow: 2800, debris: 12, stars: 1400, sphere: 64, cloud: 64, ocean: 96, cityMult: 0.55 },
  desktop: { dpr: 2, rain: 4000, snow: 5000, debris: 24, stars: 3000, sphere: 96, cloud: 96, ocean: 128, cityMult: 1 },
};

export function profileKind({ isMobile, isVR }) {
  if (isVR) return "vr";
  if (isMobile) return "mobile";
  return "desktop";
}

export function getProfile({ isMobile, isVR }) {
  return PROFILES[profileKind({ isMobile, isVR })];
}
